import { styled } from '@mui/material';
import { Link } from 'components/lib';

export const WarningLink = styled(Link)(({ theme }) => ({
  color: theme.palette.error.main,
}));
